import apiFactory from '@api/app'
import { Module } from 'vuex'
import { Route } from 'vue-router'
import { Store, App } from '@/types'
import cookies from '@/utils/cookies'

const api = apiFactory()

const storeModule: Module<App.ModuleState, Store.RootState> = {
  namespaced: true,
  state: {
    baseURL: cookies.getCookie('baseURL') || process.env.VUE_APP_BASE_API,
    isBranchAvailable: false
  },
  mutations: {
    SET_BASE_URL: (state, baseURL) => {
      state.baseURL = baseURL
    },
    SET_BRANCH_AVAILABILITY: (state, isBranchAvailable) => {
      state.isBranchAvailable = isBranchAvailable
    },
    SET_LAST_VISITED_ROUTE: (state, route: Route) => {
      state.lastVisitedRoute = route
    }
  },
  actions: {
    SetBaseURL ({ commit }, baseURL) {
      commit('SET_BASE_URL', baseURL)
    },
    SetLastRoute ({ commit }, route: Route) {
      commit('SET_LAST_VISITED_ROUTE', route)
    },
    async TestNetworkConnection () {
      await api.testNetworkConnection()
    },
    async TestBranchAvailability ({ commit, getters }) {
      commit('SET_BRANCH_AVAILABILITY', await api.testBranchAvailability())
      return getters.isBranchAvailable
    },
    GetStoreRating (_, appId: string) {
      return api.getStoreRating(appId)
    }
  },
  getters: {
    byKey: state => (key: keyof App.ModuleState) => state[key],
    baseURL: state => state.baseURL,
    isBranchAvailable: state => state.isBranchAvailable,
    lastVisitedRoute: state => state.lastVisitedRoute
  }
}

export default storeModule
